// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  1. Use a more-intuitive box-sizing model.
*/
*,
*::before,
*::after {
  box-sizing: border-box;
}
/*
  2. Remove default margin
*/
* {
  margin: 0;
}
/*
  Typographic tweaks!
  3. Add accessible line-height
  4. Improve text rendering
*/
body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}
/*
  5. Improve media defaults
*/
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}
/*
  6. Remove built-in form typography styles
*/
input,
button,
textarea,
select {
  font: inherit;
}
/*
  7. Avoid text overflows
*/
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}
/*
  8. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

:root {
  /* Brand colors */

  --forest-green-h: 191;
  --forest-green-s: 41%;
  --forest-green-l: 23%;
  --forest-green-hsl: var(--forest-green-h), var(--forest-green-s),
    var(--forest-green-l);

  --accent-lime-h: 75;
  --accent-lime-s: 100%;
  --accent-lime-l: 50%;
  --accent-lime-hsl: var(--accent-lime-h), var(--accent-lime-s),
    var(--accent-lime-l);

  /* Other */

  --polkadot-pink-h: 328;
  --polkadot-pink-s: 100%;
  --polkadot-pink-l: 45%;
  --polkadot-pink-hsl: var(--polkadot-pink-h), var(--polkadot-pink-s),
    var(--polkadot-pink-l);
}

body {
  margin: 0;
  height: 100%;
  min-height: 100vh;
  font-weight: 400;
  background: linear-gradient(
    135deg,
    hsl(var(--forest-green-h), var(--forest-green-s), 30%),
    hsl(var(--forest-green-h), var(--forest-green-s), 18%)
  );
  color: #333;
}

h1,
h2,
h3,
h4 {
  font-weight: 500;
  color: hsl(var(--forest-green-hsl));
}

h1 {
  font-size: 2.2rem;
  margin-bottom: 1rem;
}

.App {
  text-align: center;
  padding: 20px;
}

.App-header {
  background-color: #ffffff;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  color: #333;
  max-width: 800px;
  margin: 40px auto;
}

.App-header .intro {
  margin: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.App-header .logo {
  width: 100%;
  max-width: 250px;
}

.App-description {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 1.2em;
  color: #555;
}

.App-info {
  text-align: left;
  margin: 20px 0;
}

.App-info h2 {
  font-size: 1.5em;
  margin-bottom: 10px;
}

.App-info ul {
  list-style-type: disc;
  margin-left: 1rem;
  padding-left: 1rem;
}

.App-info li {
  margin-bottom: 10px;
}

.App-button {
  font-size: 1em;
  padding: 10px 20px;
  margin: 10px;
  color: black;
  background-color: hsl(var(--accent-lime-hsl));
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.App-button:hover {
  background-color: hsl(var(--accent-lime-h), var(--accent-lime-s), 45%);
}

.App-input {
  font-size: 1em;
  padding: 10px;
  margin: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: calc(100% - 40px);
  max-width: 400px;
}

.App-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.App-table th,
.App-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.App-table th {
  background-color: #f2f2f2;
  text-align: left;
}

.App-warning {
  color: red;
  font-weight: bold;
  margin: 20px 0;
}

.App-footer {
  font-size: 0.85em;
  color: white;
}

.App-footer a {
  color: white;
}

.polkadot-button {
  background-color: hsl(var(--polkadot-pink-hsl));
  color: white; /* White text */
}

.polkadot-button:hover {
  background-color: hsl(var(--polkadot-pink-h), var(--polkadot-pink-s), 35%);
}

.note-box {
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
}

.note-box p {
  margin: 0;
}

.note-box.warning {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
}

.note-box.info {
  background-color: #cce5ff;
  border: 1px solid #b8daff;
  color: #004085;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;;;EAGE,sBAAsB;AACxB;AACA;;CAEC;AACD;EACE,SAAS;AACX;AACA;;;;CAIC;AACD;EACE,gBAAgB;EAChB,mCAAmC;AACrC;AACA;;CAEC;AACD;;;;;EAKE,cAAc;EACd,eAAe;AACjB;AACA;;CAEC;AACD;;;;EAIE,aAAa;AACf;AACA;;CAEC;AACD;;;;;;;EAOE,yBAAyB;AAC3B;AACA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;;EAEjB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB;yBACuB;;EAEvB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB;wBACsB;;EAEtB,UAAU;;EAEV,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB;0BACwB;AAC1B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB;;;;GAIC;EACD,WAAW;AACb;;AAEA;;;;EAIE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,YAAY,EAAE,eAAe;AAC/B;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["/*\n  1. Use a more-intuitive box-sizing model.\n*/\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n/*\n  2. Remove default margin\n*/\n* {\n  margin: 0;\n}\n/*\n  Typographic tweaks!\n  3. Add accessible line-height\n  4. Improve text rendering\n*/\nbody {\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n/*\n  5. Improve media defaults\n*/\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n/*\n  6. Remove built-in form typography styles\n*/\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n/*\n  7. Avoid text overflows\n*/\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n/*\n  8. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n}\n\n:root {\n  /* Brand colors */\n\n  --forest-green-h: 191;\n  --forest-green-s: 41%;\n  --forest-green-l: 23%;\n  --forest-green-hsl: var(--forest-green-h), var(--forest-green-s),\n    var(--forest-green-l);\n\n  --accent-lime-h: 75;\n  --accent-lime-s: 100%;\n  --accent-lime-l: 50%;\n  --accent-lime-hsl: var(--accent-lime-h), var(--accent-lime-s),\n    var(--accent-lime-l);\n\n  /* Other */\n\n  --polkadot-pink-h: 328;\n  --polkadot-pink-s: 100%;\n  --polkadot-pink-l: 45%;\n  --polkadot-pink-hsl: var(--polkadot-pink-h), var(--polkadot-pink-s),\n    var(--polkadot-pink-l);\n}\n\nbody {\n  margin: 0;\n  height: 100%;\n  min-height: 100vh;\n  font-weight: 400;\n  background: linear-gradient(\n    135deg,\n    hsl(var(--forest-green-h), var(--forest-green-s), 30%),\n    hsl(var(--forest-green-h), var(--forest-green-s), 18%)\n  );\n  color: #333;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  font-weight: 500;\n  color: hsl(var(--forest-green-hsl));\n}\n\nh1 {\n  font-size: 2.2rem;\n  margin-bottom: 1rem;\n}\n\n.App {\n  text-align: center;\n  padding: 20px;\n}\n\n.App-header {\n  background-color: #ffffff;\n  padding: 2rem;\n  border-radius: 1rem;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  color: #333;\n  max-width: 800px;\n  margin: 40px auto;\n}\n\n.App-header .intro {\n  margin: 2rem 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.App-header .logo {\n  width: 100%;\n  max-width: 250px;\n}\n\n.App-description {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 1.2em;\n  color: #555;\n}\n\n.App-info {\n  text-align: left;\n  margin: 20px 0;\n}\n\n.App-info h2 {\n  font-size: 1.5em;\n  margin-bottom: 10px;\n}\n\n.App-info ul {\n  list-style-type: disc;\n  margin-left: 1rem;\n  padding-left: 1rem;\n}\n\n.App-info li {\n  margin-bottom: 10px;\n}\n\n.App-button {\n  font-size: 1em;\n  padding: 10px 20px;\n  margin: 10px;\n  color: black;\n  background-color: hsl(var(--accent-lime-hsl));\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.App-button:hover {\n  background-color: hsl(var(--accent-lime-h), var(--accent-lime-s), 45%);\n}\n\n.App-input {\n  font-size: 1em;\n  padding: 10px;\n  margin: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: calc(100% - 40px);\n  max-width: 400px;\n}\n\n.App-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 20px 0;\n}\n\n.App-table th,\n.App-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n}\n\n.App-table th {\n  background-color: #f2f2f2;\n  text-align: left;\n}\n\n.App-warning {\n  color: red;\n  font-weight: bold;\n  margin: 20px 0;\n}\n\n.App-footer {\n  font-size: 0.85em;\n  color: white;\n}\n\n.App-footer a {\n  color: white;\n}\n\n.polkadot-button {\n  background-color: hsl(var(--polkadot-pink-hsl));\n  color: white; /* White text */\n}\n\n.polkadot-button:hover {\n  background-color: hsl(var(--polkadot-pink-h), var(--polkadot-pink-s), 35%);\n}\n\n.note-box {\n  padding: 15px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n}\n\n.note-box p {\n  margin: 0;\n}\n\n.note-box.warning {\n  background-color: #fff3cd;\n  border: 1px solid #ffeeba;\n  color: #856404;\n}\n\n.note-box.info {\n  background-color: #cce5ff;\n  border: 1px solid #b8daff;\n  color: #004085;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
